var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"8","height":"14","viewBox":"0 0 8 14"}},_vm.$listeners),[_c('path',{attrs:{"fill":"#0f3261","d":"M-895.74-959.463a.85.85 0 101.198 1.207l6-6a.85.85 0 000-1.202l-5.997-5.996a.85.85 0 10-1.205 1.198l5.399 5.4z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }